<template>
  <DashboardWrapper
    :is-mobile="$q.screen.xs"
    :restrict-pre-life="restrictPreLifeAccess"
    :display-empty-state="displayEmptyState"
    :org-contact-phone="theme().novatedBrand?.support?.phone"
    :welcome-title="welcomeTitle"
    :welcome-body="welcomeBody"
    :display-novated-information="
      (!hasSettlement && !hasLeases && !leasesLoading) || displayEmptyState
    "
    :information-body="informationBody"
    :information-link="informationLink"
    :information-title="informationTitle"
  />
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { getAsset, getEnv } from 'ecx.saigon.ui.common';
import { USER_ACCESS_LEVEL } from '@/utils/constants';

export default {
  name: 'DashboardWidget',
  metaInfo: {
    title: 'Dashboard |'
  },
  data() {
    return {
      images: {},
      links: {}
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      leasesLoading: (state) => state.lease.leasesLoading
    }),
    ...mapGetters('application', ['hasStartedApplication', 'hasSettlement']),
    ...mapGetters('settlement', ['hasSettlementCompleted']),
    ...mapGetters('user', [
      'theme',
      'restrictPreLifeAccess',
      'userIsAccessLevel'
    ]),
    ...mapGetters('lease', ['hasLeases']),
    displayEmptyState() {
      return (
        this.userIsAccessLevel([USER_ACCESS_LEVEL.DASHBOARD]) &&
        !this.hasLeases &&
        !this.leasesLoading
      );
    },
    welcomeTitle() {
      if (this.hasSettlementCompleted) {
        return undefined;
      }

      const name = this.user.profile.firstName;
      return name ? `Welcome back, ${name}!` : 'Welcome back!';
    },
    welcomeBody() {
      if (this.restrictPreLifeAccess || this.hasStartedApplication) {
        return undefined;
      }

      return 'A novated lease could save you thousands on your next car.';
    },
    informationTitle() {
      return this.hasStartedApplication
        ? 'Your vehicle. Your choice.'
        : 'If you’re not leasing, you’re missing out!';
    },
    informationBody() {
      return this.hasStartedApplication
        ? 'A novated lease gives you the freedom and flexibility to choose the exact make, model, colour and accessories you want and that suit your needs.'
        : 'A novated lease is one of the most cost-effective and the easiest ways to get into your next car. Your finance and most of your running costs are bundled together and paid from your pre-tax salary. This could potentially save you thousands in tax every year of your lease!';
    },
    informationLink() {
      return this.hasStartedApplication ? undefined : this.links.information;
    }
  },
  async beforeMount() {
    const env = await getEnv();
    this.links = {
      ...this.links,
      information: env.VUE_APP_NOVATED_INFORMATION_LINK
    };
    this.images = {
      ...this.images,
      information: await getAsset(this.$Constants.NOVATED_INFORMATION_IMG_PATH)
    };
  },
  components: {
    DashboardWrapper: () => import('../../components/page/dashboard-wrapper')
  }
};
</script>
